import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Grid2,
  Divider
} from "@mui/material";
import MeetingCard from '../components/Meeting/MeetingCard';
import { getAllThirtyDaysMeetings } from '../apis/apiList/meetingApi';
import { useApp } from "../context/AppContext";
import EventBusyIcon from "@mui/icons-material/EventBusy";

const MeetingList = () => {
  const [meetings, setMeetings] = useState([]);
  const [upcomingMeetings, setUpcomingMeetings] = useState([]);
  const [pastMeetings, setPastMeetings] = useState([]);
  const { userDetails } = useApp();
  
  useEffect(() => {
    async function getMeetingList() {
      const data = await getAllThirtyDaysMeetings({
        headers: { "x-access-token": userDetails.jwtToken },
      });
      console.log('meetings', data);
      setUpcomingMeetings(data.upcoming);
      setPastMeetings(data.past);
    }
    getMeetingList();
  }, []);
  
  const headingStyle = {
    color: '#fff',
    backgroundColor: '#565c68',
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '15px'
  }


  return (

    <Box
    sx={{
      minHeight: "100vh",
      // bgcolor: "#f9f9fb",
      // p: { xs: 2, md: 4 },
      marginBottom: '30px'
    }}
    >
      <Box>
        <Typography variant="h2" fontWeight="bold" gutterBottom>
            Meetings
          </Typography>
        <Divider sx={{ my: 2 }} />
      </Box>
      <Box>
        <Box mb={4}>
          <Typography variant="h3" fontWeight="bold" gutterBottom sx={headingStyle}>
            Upcoming Meetings
          </Typography>

          {/* <Divider sx={{ my: 2 }} /> */}

          {upcomingMeetings.length > 0 ? (
            <Grid2 container spacing={2} justifyContent="flex-start">
              {upcomingMeetings.map((meeting, idx) => (
                <Grid2 key={idx} xs={12} sm={6} md={4} lg={3}>
                  <MeetingCard meeting={meeting} />
                </Grid2>
              ))}
            </Grid2>
          ) : (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              sx={{
                py: 6,
                px: 2,
                border: "2px dashed #ccc",
                borderRadius: 4,
                bgcolor: "background.paper",
                boxShadow: 2,
                width: "100%",
              }}
            >
              <EventBusyIcon sx={{ fontSize: 60, color: "text.secondary", mb: 2 }} />
              <Typography variant="h5" fontWeight="bold" gutterBottom>
                No Upcoming Meetings Found
              </Typography>
              <Typography variant="body1" color="text.secondary" gutterBottom>
                You don’t have any upcoming meetings.
              </Typography>
              {/* <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2, borderRadius: "20px", px: 3 }}
                onClick={() => alert("Create Meeting clicked")}
              >
                Create Meeting
              </Button> */}
            </Box>
          )}
        </Box>
        <Box>
          <Typography variant="h3" fontWeight="bold" gutterBottom sx={headingStyle}>
            Past Meetings
          </Typography>

          {/* <Divider sx={{ my: 2 }} /> */}

          {pastMeetings.length > 0 ? (
            <Grid2 container spacing={2} justifyContent="flex-start">
              {pastMeetings.map((meeting, idx) => (
                <Grid2 key={idx} xs={12} sm={6} md={4} lg={3}>
                  <MeetingCard meeting={meeting} />
                </Grid2>
              ))}
            </Grid2>
          ) : (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              sx={{
                py: 6,
                px: 2,
                border: "2px dashed #ccc",
                borderRadius: 4,
                bgcolor: "background.paper",
                boxShadow: 2,
                width: "100%",
              }}
            >
              <EventBusyIcon sx={{ fontSize: 60, color: "text.secondary", mb: 2 }} />
              <Typography variant="h5" fontWeight="bold" gutterBottom>
                No Past Meetings Found
              </Typography>
              <Typography variant="body1" color="text.secondary" gutterBottom>
                You don’t have any past meetings.
              </Typography>
              {/* <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2, borderRadius: "20px", px: 3 }}
                onClick={() => alert("Create Meeting clicked")}
              >
                Create Meeting
              </Button> */}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default MeetingList;